import { render } from "./VuePagoPluxAR.vue?vue&type=template&id=8dfe717a"
import script from "./VuePagoPluxAR.vue?vue&type=script&lang=js"
export * from "./VuePagoPluxAR.vue?vue&type=script&lang=js"

import "./VuePagoPluxAR.vue?vue&type=style&index=0&id=8dfe717a&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__